import React, { Component, PropTypes } from 'react'
import cx from 'classnames'

export class ProgressBar extends Component {
  static propTypes = {
    className: PropTypes.string,
    progress: PropTypes.any,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    return (
      <div {...this.props} className={cx('progress-bar', this.props.className, { 'full': Number(this.props.progress) === 100 })}>
        <div className="progress-bar--progress" style={{ width: this.props.progress + '%' }} />
      </div>
    )
  }
}
